import { Textarea } from '@/components/ui/textarea';

/** Free-text topic with one-tap preset chips that fill it. */
export function TopicInput({
  presets,
  value,
  onChange,
  maxLength,
  placeholder,
  hint,
}: {
  presets: readonly { id: string; emoji: string; label: string; topic: string }[];
  value: string;
  onChange: (value: string) => void;
  maxLength: number;
  placeholder: string;
  hint: string;
}) {
  return (
    <>
      <div className="mb-2 flex flex-wrap gap-2">
        {presets.map((preset) => (
          <button
            key={preset.id}
            type="button"
            onClick={() => onChange(preset.topic)}
            className="rounded-full border border-border px-3 py-1 text-xs font-medium transition-colors hover:border-primary/50 hover:bg-primary/5"
          >
            <span aria-hidden="true">{preset.emoji}</span> {preset.label}
          </button>
        ))}
      </div>
      <Textarea
        value={value}
        maxLength={maxLength}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        rows={2}
      />
      <p className="mt-2 text-xs leading-5 text-muted-foreground">{hint}</p>
    </>
  );
}
